import React from "react";

export default function DragAndDrop({ children, onDrop }) {
  const dropZone = React.createRef();

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files.length) {
      onDrop(e.dataTransfer.files);
    }
  };

  React.useEffect(() => {
    const div = dropZone.current;
    if (div) {
      div.addEventListener("dragenter", handleDragEnter);
      div.addEventListener("dragleave", handleDragLeave);
      div.addEventListener("dragover", handleDragOver);
      div.addEventListener("drop", handleDrop);
    }

    return () => {
      if (div) {
        div.removeEventListener("dragenter", handleDragEnter);
        div.removeEventListener("dragleave", handleDragLeave);
        div.removeEventListener("dragover", handleDragOver);
        div.removeEventListener("drop", handleDrop);
      }
    };
  });

  return <div ref={dropZone}>{children}</div>;
}
